/* src/app/modules/search/components/doc-view/components/comments/components/editor/editor.component.scss */
::ng-deep .ql-mention-list-container {
  background-color: var(--surface-ground);
  border: none;
  border-radius: 4px;
  box-shadow: var(--primary-shadow);
  overflow: auto;
  width: 186px;
  z-index: 9001;
}
::ng-deep .p-editor-container .p-editor-content .ql-editor {
  border: none;
}
::ng-deep .p-editor-container .p-editor-content.ql-snow {
  border: none;
}
::ng-deep .ql-toolbar.ql-snow {
  border-bottom: 1px solid var(--surface-border);
  border-top: none;
  border-left: none;
  border-right: none;
}
::ng-deep .ql-mention-list-item {
  cursor: pointer;
  line-height: 2rem;
  padding: 0 1rem;
  vertical-align: middle;
  font-size: 0.8rem;
  border: none;
}
::ng-deep .ql-mention-list-item.selected {
  background-color: var(--primary-500);
  color: var(--surface-0);
  border: none;
}
::ng-deep .mention {
  background: none;
  color: var(--primary-500);
}
::ng-deep .ql-mention-list .ql-mention-list-item {
  cursor: pointer;
  padding-left: 2rem;
  position: relative;
}
::ng-deep .ql-mention-list .ql-mention-list-item::before {
  content: "";
  background-image: url("./media/profile_black.png");
  height: 1.3rem;
  width: 1.3rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  position: absolute;
  left: 0.5rem;
  top: 0.3rem;
}
::ng-deep .ql-mention-list .ql-mention-list-item.selected::before {
  color: white;
  background-image: url("./media/profile.png");
}
/*# sourceMappingURL=editor.component.css.map */
